// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"381":"9ec9b1d7","496":"f925816c","668":"fda18f1e"}[chunkId] + ".chunk.js";
};